import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { RefinementListProps, useRefinementList } from 'react-instantsearch';
import { FormCheckbox } from '@hvcgroep/design-system';

import './style.scss';
import gtm from '../../../helpers/gtm';
import Button from '../../Button';

export interface SearchFacetRefinementCheckboxesProps extends RefinementListProps {
  showMoreText?: string;
  showLessText?: string;
  itemClassName?: string;
}

const SearchFacetRefinementCheckboxes: React.FC<SearchFacetRefinementCheckboxesProps> = (props) => {
  const { t } = useTranslation();

  const {
    attribute,
    showMore,
    showMoreText = t(['searchkit.buttons.show_more']),
    showLessText = t(['searchkit.buttons.show_less']),
    itemClassName,
  } = props;

  const {
    items,
    canToggleShowMore,
    isShowingMore,
    canRefine,
    toggleShowMore,
    refine,
  } = useRefinementList(props);

  const itemClassNames = c('Searchkit__Facet__RefinementCheckboxes__item', itemClassName);

  const fieldName = `refinementList_${attribute}`;

  const options = items.map((item) => ({
    value: item.value,
    checked: item.isRefined,
    label: (
      <span className="Searchkit__Facet__label d-flex" data-facet-label={item.label} data-facet-count={item.count}>
        <span className="Searchkit__Facet__label__label">{item.label}</span>
        <span className="Searchkit__Facet__label__count ml-auto">{item.count}</span>
      </span>
    ),
    disabled: item.count === 0,
  }));

  if (!canRefine) {
    return null;
  }

  return (
    <div className="Searchkit__Facet__RefinementCheckboxes__wrapper">
      <h5>{t(`searchkit.vacancies.facets.${attribute}`)}</h5>
      {options.map((option) => (
        <FormCheckbox
          label={option.label}
          name={`${fieldName}--${option.value}`}
          checked={option.checked}
          className={itemClassNames}
          visualValidation={false}
          verticalSpacing={false}
          isFilter
          disabled={option.disabled}
          onChange={(e) => {
            // @ts-expect-error
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            gtm.trackUserEvent(`vacancies-filter-${attribute}`, option.value, e.target.checked ? 'add' : 'remove');

            refine(e.target.name.split('--')[1]!);
          }}
        />
      ))}

      {(showMore && canToggleShowMore) && (
        <Button
          className="icon-after icon-variant-2"
          type="link"
          icon={isShowingMore ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
          onClick={() => {
            toggleShowMore();
          }}
        >
          {isShowingMore ? showLessText : showMoreText}
        </Button>
      )}
    </div>
  );
};

export default SearchFacetRefinementCheckboxes;
